import { render, staticRenderFns } from "./edit-staff-modal.vue?vue&type=template&id=e82f2cd2&"
import script from "./edit-staff-modal.vue?vue&type=script&lang=js&"
export * from "./edit-staff-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports